import React from 'react'

import Select from '@mui/joy/Select'
import Option from '@mui/joy/Option'
import ListItemDecorator from '@mui/joy/ListItemDecorator'

import { useController } from 'react-hook-form'

import FormControl from '@mui/joy/FormControl'
import FormHelperText from '@mui/joy/FormHelperText'
import FormLabel from '@mui/joy/FormLabel'
import InfoOutlined from '@mui/icons-material/InfoOutlined'

import countryRegionData from 'country-region-data/dist/data-umd'
import FlagImg from './FlagImg'
// import { allCountries } from 'country-region-data'
// console.log(countryRegionData)

function renderOptions (countryCode) {
  if (!countryCode) { return null }

  // console.log('RegionSelectInFormControl:', { countryCode, countryData })

  const countryData = countryRegionData
    .find((c) => c.countryShortCode === countryCode)

  if (!countryData) { throw new Error(`should never happen, unknown country code ${countryCode}`) }

  return countryData.regions.map(({ shortCode, name }, index) => {
    return (
      <Option key={index} value={shortCode}>
        {countryCode === 'US'
          ? (
            <ListItemDecorator>
              <FlagImg lowercasedCode={`${countryCode}-${shortCode}`} />
            </ListItemDecorator>
            )
          : null}
        {name}
      </Option>
    )
  })
}

const RegionSelectInFormControl = ({ countryCode, control, name, label, required }) => {
  const {
    field,
    fieldState,
  } = useController({
    name: name,
    // rules: rules,
    control: control,
  })

  /// /////////////////

  // console.log('RegionSelectInFormControl:', { field, fieldState })

  // if country removed - remove state too
  React.useEffect(() => {
    // console.log('RegionSelectInFormControl effect invoked')
    if (!countryCode) {
      // console.log('RegionSelectInFormControl effect setting')
      field.onChange(null)
    }
  }, [countryCode])

  const regionOptions = React.useMemo(() => renderOptions(countryCode), [countryCode])

  // console.log('regionOptions', regionOptions)

  const placeholder = countryCode === 'US'
    ? 'Choose a state'
    : 'Choose a region/province'

  /// /////////////////

  const startDecorator = countryCode === 'US' && field.value ? <FlagImg lowercasedCode={`${countryCode}-${field.value}`} /> : null

  // console.log('field.value', field.value)
  // const value = field.value || null // if unlogged - WHYYYYYY useControllableReducer: The useSelect component is changing an uncontrolled prop to be controlled: selectedValues

  return (
    <FormControl required={required} error={fieldState.invalid}>
      <FormLabel>{label}</FormLabel>
      <Select startDecorator={startDecorator} disabled={!countryCode} placeholder={placeholder} value={field.value} onChange={(_event, option) => field.onChange(option)}>
        {regionOptions}
      </Select>
      {fieldState.error && <FormHelperText><InfoOutlined />{fieldState.error.message}</FormHelperText>}
    </FormControl>
  )
}

export default RegionSelectInFormControl
